// @flow
// $FlowFixMe
import React, { useMemo, useState } from "react";
import { get, noop, findIndex } from "lodash";
import type { RaceCardRunner, RaceTypeCodeEnum } from "@tvg/types/Race";
import type { BinaryFn, UnaryFn } from "@tvg/types/Functional";
import RunnerButton from "../../_atoms/RunnerButton";
import MagnetScrollArea from "../../_templates/MagnetScrollArea";
import RunnerItem from "./styled-components";

type Props = {
  runners: RaceCardRunner[],
  activeRunner: string,
  onRunnerClick: BinaryFn<string, string, void>,
  raceTypeCode: RaceTypeCodeEnum,
  changeIndex: UnaryFn<number, void>
};

const PastPerformanceRunnerSelector = (props: Props) => {
  const { runners, activeRunner, onRunnerClick, raceTypeCode } = props;

  const [isFirstRender, setFirstRender] = useState(true);

  const findActiveRunner = () =>
    findIndex(runners, (runner) => runner.horseName === activeRunner);

  const renderRunners = () =>
    runners.map((runner) => (
      <RunnerItem>
        <RunnerButton
          key={`runnerButton-${get(runner, "runnerId")}`}
          raceTypeCode={raceTypeCode}
          runnerId={get(runner, "runnerId")}
          runnerName={get(runner, "horseName")}
          entityRunnerId={get(runner, "entityRunnerId")}
          isActive={get(runner, "horseName") === activeRunner}
          onRunnerClick={onRunnerClick}
        />
      </RunnerItem>
    ));

  return useMemo(
    () =>
      runners.length > 0 && (
        <MagnetScrollArea
          onHandleTransition={() => setFirstRender(false)}
          activeIndex={isFirstRender ? findActiveRunner() : null}
          isFreeScroll
        >
          {renderRunners()}
        </MagnetScrollArea>
      ),
    [isFirstRender, activeRunner, JSON.stringify(runners)]
  );
};

PastPerformanceRunnerSelector.defaultProps = {
  runners: [],
  activeRunner: "",
  onRunnerClick: noop,
  changeIndex: noop,
  raceTypeCode: "T"
};

export default PastPerformanceRunnerSelector;
